import React, { VoidFunctionComponent, ComponentProps } from 'react';
import { StrictReactNode } from '../../types/StrictReactNode';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import styles from './ExpandableInlineCreationForm.module.css';

export type ExpandableInlineCreationFormProps = PropsWithoutChildren<
  ComponentProps<'div'>
> & {
  opened: boolean;
  label: string;

  openedContent: StrictReactNode;
  notOpenedContent: StrictReactNode;
  buttons: StrictReactNode;
};

export type ExpandableInlineCreationFormContent = {
  renderOpenedContent: () => StrictReactNode | Array<StrictReactNode>;
  renderNotOpenedContent: () => StrictReactNode | Array<StrictReactNode>;
  renderButtons: () => StrictReactNode | Array<StrictReactNode>;
};

export const ExpandableInlineCreationForm: VoidFunctionComponent<ExpandableInlineCreationFormProps> =
  React.memo((props) => {
    const {
      opened,
      label,
      className,
      openedContent,
      notOpenedContent,
      buttons,
      ...remainingProps
    } = prepareProps({ props, ignoreChildren: true });

    if (!opened) {
      return <div {...remainingProps}>{notOpenedContent}</div>;
    }

    return (
      <div
        {...remainingProps}
        className={classes(className, styles.container)}
      >
        <div className={styles.label}>{label}</div>

        {openedContent}

        {buttons ? (
          <div className={styles.buttonWrapper}>{buttons}</div>
        ) : undefined}
      </div>
    );
  });
